export default "__VITE_ASSET__9AoVl4GO__"